import CrmMultiTracking from './crm'
import GtmTracking from './gtm'
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export default function registerGlobals(app, store) {
    
    const hostname = store.getters['settings/from'].hostname
    app.config.globalProperties.$CookieConsent = CookieConsent
    app.config.globalProperties.$crm = new CrmMultiTracking(hostname)
    app.config.globalProperties.$gtm = new GtmTracking()

    app.config.globalProperties.$getPromoCode = (form, ateneo) => {
        const meseAttuale = new Date().getMonth() + 1;
        let promo_code = '';
        switch (meseAttuale) {
            case 9: // Settembre
                console.log(meseAttuale, 'Settembre')
                promo_code = 'BACKTOUNI'
                if (form.convention.label == 'MULTIVERSITY CARD - START') {
                    if (form.program.label == 'BASE 26_27') {
                        promo_code = 'START BASE 2627 PROMOBACKTOUNI'
                    } else if (form.program.label == 'FULL ACCESS 26_27') {
                        promo_code = 'START FULL ACCESS 2627 PROMOBACKTOUNI'
                    } else if (form.program.label == 'FULL ACCESS PLUS 26_27') {
                        promo_code = 'START FULL ACCESS PLUS 2627 PROMOBACKTOUNI'
                    }
                }
                break;
            case 10: // Ottobre
                console.log(meseAttuale, 'Ottobre')
                promo_code = 'BACKTOUNI'
                if (form.convention.label == 'MULTIVERSITY CARD - START') {
                    if (form.program.label == 'BASE 26_27') {
                        promo_code = 'START BASE 2627 PROMOBACKTOUNI'
                    } else if (form.program.label == 'FULL ACCESS 26_27') {
                        promo_code = 'START FULL ACCESS 2627 PROMOBACKTOUNI'
                    } else if (form.program.label == 'FULL ACCESS PLUS 26_27') {
                        promo_code = 'START FULL ACCESS PLUS 2627 PROMOBACKTOUNI'
                    }
                } else if (form.convention.label == 'MULTIVERSITY CARD' && app.config.globalProperties.$isTransfersReturns(form.entrance.label) && app.config.globalProperties.$isTriennale(form.course.code)) {
                    promo_code = 'RIPARTI CON NOI'
                }
                break;
            case 11: // Novembre
             console.log(meseAttuale, 'Novembre')
                promo_code = 'BACKTOUNI'
                if (form.convention.label == 'MULTIVERSITY CARD - START') {
                    if (form.program.label == 'BASE 26_27') {
                        promo_code = 'START BASE 2627 PROMOBACKTOUNI'
                    } else if (form.program.label == 'FULL ACCESS 26_27') {
                        promo_code = 'START FULL ACCESS 2627 PROMOBACKTOUNI'
                    } else if (form.program.label == 'FULL ACCESS PLUS 26_27') {
                        promo_code = 'START FULL ACCESS PLUS 2627 PROMOBACKTOUNI'
                    }
                } else if (form.convention.label == 'MULTIVERSITY CARD' && app.config.globalProperties.$isTransfersReturns(form.entrance.label) && app.config.globalProperties.$isTriennale(form.course.code)) {
                    promo_code = 'RIPARTI CON NOI'
                } else if (form.convention.label == 'PUBBLICA AMMINISTRAZIONE' && app.config.globalProperties.$isTriennale(form.course.code) && ateneo == 'PEGASO') {
                    promo_code = 'PROMO PA'
                }
                break;
            default:
                promo_code = ''
        }
        return promo_code
    }

    app.config.globalProperties.$isTriennale = (code) => {
        const courseCodes = [
            "001",
            "04SCUMA",
            "011",
            "012",
            "013",
            "014",
            "02GIURI",
            "016",
            "03GIURI",
            "018",
            "00SCUMA",
            "020",
            "02SCUMA",
            "022",
            "024",
            "026",
            "003",
            "07GIURI",
            "036",
            "004",
            "004",
            "040",
            "041",
            "06SCUMA",
            "01GIURI",
            "007",
            "008",
            "008",
            "009",
            "009",
            "053",
            "00GIURI"
        ];
        return courseCodes.includes(code)
    }

    app.config.globalProperties.$isTransfersReturns = (entrance) => {
        return entrance != 'Nuova Immatricolazione' ? true : false
    }

    app.config.globalProperties.$university = (index) => {
        switch (index) {
            case 'PEGASO':
                return {
                    name: 'Università Telematica Pegaso',
                    logo: '',
                    api: 'pegaso',
                    direzionale_id: 5,
                    ecp: 'ecp'
                } 
            case 'MERCATORUM': 
                return  {
                    name: 'Universitas Mercatorum',
                    logo: '',
                    api: 'mercatorum',
                    direzionale_id: 4,
                    ecp: 'ei-point'
                }
        }
    }

   app.config.globalProperties.$crm_oc_category = (course) => {
        switch (course.cat_id) {
            case 1:
                if (course.id_level == 1) {
                    return 3
                } else {
                    return 4
                }
            case 3:
            case 4:
                return 5
            case 2:
            case 6:
            case 8: 
            case 9:
                return 7
            default:
                return 15
        }
    }

    app.config.globalProperties.$formattaNumeroItaliano = (numero, decimali = 2) => {
        const formatter = new Intl.NumberFormat('it-IT', {
            style: 'decimal',
            minimumFractionDigits: decimali,
            maximumFractionDigits: decimali,
            useGrouping: true
        });
        return formatter.format(numero);
    }
}